import { render, staticRenderFns } from "./CreateStockHeader.vue?vue&type=template&id=dd5c20be&"
import script from "./CreateStockHeader.vue?vue&type=script&lang=js&"
export * from "./CreateStockHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports